import React, { useContext, useState, useEffect } from "react";
import LoginStyle from "./LoginStyle.module.css";
//import react router dom
import { Link, useNavigate } from "react-router-dom";
//import components
import { LoginUser } from "../services/api";
import { ValidationLogin } from "../helper/functions";
import { ButtonLogin } from "../components/UI/Button";

//import storage
import { setItem } from "../core/storage/storage";
//import context
import { AuthContext } from "../context/AuthContextProvider";
//material
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
//toastify
import { toastify } from "../helper/toast";

//start functions

const Login = () => {
  const Navigate = useNavigate();
  const authContext = useContext(AuthContext);
  //states
  const [value, setValue] = useState({
    email: "",
    password: "",
    remember: false,
  });
  const [msg, setMsg] = useState();
  const [errors, setErrors] = useState({});
  const [remember, setRemember] = useState(false);
  const [touched, setTouched] = useState({});
  //use effect
  useEffect(() => {
    setErrors(ValidationLogin(value));
  }, [value, touched]);

  //change function
  const onChangeHandler = (event) => {
    if (event.target.name === remember) {
      setValue({ ...value, [event.target.name]: event.target.checked });
    } else {
      setValue({ ...value, [event.target.name]: event.target.value });
    }
  };
  //submut handler
  const submitHandler = async (event) => {
    event.preventDefault();

    if (!Object.keys(errors).length) {
      const user = await LoginUser({
        email: value.email,
        password: value.password,
      });
      console.log(user.data.result);
      try {
        authContext.login(user.data.result);
        setRemember(value.remember);
        if (remember) {
          setItem("token", user.data.result.jwtToken);
          setItem(
            "studentData",
            user.result.JSON.stringify(user.data.result.studentModel)
          );
        }
        if (user) {
          await Navigate("/accant/dashBoard");
          toastify("خوش آمدید", "success");
        } else {
          toastify("ایمیل یا پسورد اشتباه است!", "error");
          setTouched({
            email: "true",
            password: "true",
          });
        }
      } catch (error) {
        console.log(error);
      }
      if (!user) {
        setMsg("password or email is wrong");
      }
    }
    setTouched({
      email: "true",
      password: "true",
    });
  };
  //onfocus
  const onFocusHandler = (event) => {
    setTouched({ ...touched, [event.target.name]: true });
  };

  return (
    <div className={LoginStyle.container}>
      <form onSubmit={submitHandler} className={LoginStyle.form}>
        <h3>ورود به حساب کاربری</h3>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {msg ? <h5 className={LoginStyle.p}>{msg}</h5> : null}{" "}
        </div>
        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 3 },
          }}
          noValidate
          autoComplete="off"
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div>
              <TextField
                sx={{ m: 1 }}
                error={touched.email && errors.email}
                onFocus={onFocusHandler}
                id="outlined-basic"
                label="email"
                name="email"
                type="email"
                value={value.email}
                onChange={onChangeHandler}
                variant="outlined"
              />
              <p className={LoginStyle.p}>{touched.email && errors.email}</p>
            </div>
            <div>
              <TextField
                sx={{ m: 1 }}
                error={touched.password && errors.password}
                variant="filled"
                onFocus={onFocusHandler}
                id="outlined-basic"
                label="password"
                name="password"
                type="password"
                value={value.password}
                onChange={onChangeHandler}
                variant="outlined"
              />
              <p className={LoginStyle.p}>
                {touched.password && errors.password}
              </p>
            </div>{" "}
          </div>
          <div
            style={{
              direction: "rtl",
              alignItems: "center",
              display: "flex",
              flexFlow: "row-reverse",
              justifyContent: "space-evenly",
            }}
          >
            <FormControlLabel
              name="remember"
              control={<Checkbox />}
              label=""
              id="l"
            />
            <span className={LoginStyle.span}>
              <label for="l">مرا بخاطر بسپار</label>
            </span>
          </div>
          <ButtonLogin onClick={submitHandler}>ورود</ButtonLogin>
          <div className={LoginStyle.Link}>
            <Link to="/SignUp">آیا حساب کاربری دارید؟</Link>
          </div>
        </Box>
      </form>
    </div>
  );
};

export default Login;
